import React from 'react';
import { getMaturity } from '../../utils/scoring';

/**
 * Horizontal progress bar representing a score 1–5.
 * Props: score (number|null), showLabel (bool), className
 */
export default function ScoreBar({ score, showLabel = false, className = '' }) {
  const maturity = getMaturity(score);
  const pct = score ? (score / 5) * 100 : 0;

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <div className="flex-1 bg-gray-200 rounded-full h-2 overflow-hidden">
        <div
          className="h-2 rounded-full transition-all duration-300"
          style={{ width: `${pct}%`, backgroundColor: maturity.color }}
        />
      </div>
      {showLabel && (
        <span className="text-xs text-mid-grey whitespace-nowrap w-20">
          {score ? score.toFixed(1) : '—'} / 5
        </span>
      )}
    </div>
  );
}
